import axiosBase from "axios";
import debounce from "lodash/debounce";
import config from "./config";
import { getStorageAuth } from "./components/_auth/methods";
import AuthService from "./components/_auth/AuthService";

const bouncedRequest = debounce(() => {
  AuthService.trackTokenValidityTime();
}, 2000);

const axios = axiosBase.create({
  baseURL: config.apiBaseUrl,
  withCredentials: true,
  headers: { Accept: "application/json" },
  transformRequest: [
    function addCredentialsToRequest(data, headers) {
      const storageAuth = getStorageAuth();
      const accessToken = storageAuth.access_token;
      const google2faToken = storageAuth.google2fa;

      if (accessToken) {
        headers.Authorization = `Bearer ${accessToken}`;
      }

      if (google2faToken) {
        headers.google2fa = google2faToken;
      }

      if (headers.Authorization && !headers.notTracking) {
        bouncedRequest();
      }

      return data;
    },
    ...axiosBase.defaults.transformRequest
  ],
  transformResponse: [
    function transformResponse(data) {
      try {
        return JSON.parse(data);
      } catch {
        // If the response is not valid JSON (e.g. binary payloads), return the raw data as-is.
        return data;
      }
    }
  ]
});

axios.interceptors.request.use(
  (config) => {
    // List the routes which have need the trusted_device cookie
    const authRoutes = ["auth/login", "two-factor-code", "password/email", "oauth/token"];
    const requiresCredentials = authRoutes.some((route) => config.url?.includes(route));

    if (requiresCredentials) {
      config.withCredentials = true;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.CancelToken = axiosBase.CancelToken;
axios.all = axiosBase.all;

export default axios;
